import React from 'react';

import Reveal from '../ui/Reveal';
import './process.scss';

const STEPS = [
  {
    num: '01',
    title: 'Discovery call',
    text: 'We map your business, your data and your bottlenecks — no deck, just a real conversation.',
  },
  {
    num: '02',
    title: 'Scoped plan',
    text: 'A fixed-scope proposal with clear deliverables, timeline and price — no surprises later.',
  },
  {
    num: '03',
    title: 'Build & ship',
    text: 'Weekly check-ins, working software from sprint one, and a team you can actually reach.',
  },
];

export default function ProcessSection() {
  return (
    <section className="section process-section" id="process">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="eyebrow">How we work</p>
          <h2>From first call to first sprint in weeks, not quarters.</h2>
        </Reveal>

        <ol className="process-track">
          {STEPS.map((step, index) => (
            <Reveal key={step.num} delay={index * 110} as="li" className="process-step">
              <span className="process-step__node">{step.num}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
